module.exports = __webpack_public_path__ + "static/media/Exploding-Job-Offer-Dice.cfb7a040.png";